import gql from "graphql-tag";

export const CREATE_REMINDER = gql`
  mutation createReminder($input: createReminderInput) {
    createReminder(input: $input) {
      time
    }
  }
`;
